import React from 'react';

import { SessionStopWithScreen } from './SessionStopWithScreen';
import { SessionStopJustPause } from './SessionStopJustPause';
import { SessionStopMode, SessionStopProps } from './SessionStop.types';

export const SessionStop: React.FC<SessionStopProps> = React.memo<SessionStopProps>(
    ({ contentId: id, mode, play, pause, playingState, onIsSessionStoppedChanged }) => {
        if (mode === SessionStopMode.StopScreen) {
            return (
                <SessionStopWithScreen
                    play={play}
                    pause={pause}
                    playingState={playingState}
                    contentId={id}
                    onIsSessionStoppedChanged={onIsSessionStoppedChanged}
                />
            );
        }

        if (mode === SessionStopMode.JustPause) {
            return <SessionStopJustPause pause={pause} playingState={playingState} />;
        }

        return null;
    }
);
